import React from "react";
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

const TenantChargeRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("Tenant Credit", "1", "", "", "/accounting/receivables_payments/invoices/newtenantcredit"),
      RightBarMethod("Bulk Charges and Credits", "2", "", "", "/accounting/receivables_payments/invoices/bulkchargesandcredits"),
    ]),
  ];

const TenantCharge = () => {
  return (
    <div>
      <div className="pageheading">
        <h1>New Tenant Charge</h1>
        <div className="pageHeadingBtns">
          <button>Repeat Charge</button>
        </div>
      </div>
      <Form autoComplete="off" layout="vertical">
        <Card>
          <Row gutter={16}>
            <Col span={9}>
            <Form.Item label="Tenant" name="Tenant" required>
                <Select
                  showSearch
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "Tenant1",
                      label: "Tenant1",
                    },
                    {
                      value: "Tenant2",
                      label: "Tenant2",
                    },
                    {
                      value: "Tenant3",
                      label: "Tenant3",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
            <Form.Item label="Amount Received" name="AmountReceived" required>
                <InputNumber
                  addonBefore={<i className="fa-solid fa-dollar-sign"></i>}
                  initialValues="0"
                  step="0.00"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Charge Date"
                name="ChargeDate"
                required
                autoComplete="off"
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Posting Date"
                name="PostingDate"
                required
                autoComplete="off"
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={15} offset={9}>
              <Form.Item label="GL Account" name="GLAccount" required>
                <Select
                  showSearch
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "jack",
                      label: "Jack",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={15} offset={9}>
              <Form.Item label="Description" name="Description">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button type="link">Cancel</Button>
          </Col>
        </Row>
        <br />

        {/* <Notes /> */}

        {/* <AttachmentsUpload /> */}
      </Form>
      <div className="RightSidebar">
        <RightBar RightBarData={TenantChargeRightBar} />
      </div>
    </div>
  );
};

export default TenantCharge;
